import { ReactNode } from 'react';

export function StandardStepTitle({
  children
}: Readonly<{ children: ReactNode }>) {
  return (
    <p
      className="text-6 sm:text-7 font-semibold mb-0.5"
      data-testid="standard_step_title"
    >
      {children}
    </p>
  );
}
